import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions/productData';
import { setErrorObject } from '../../actions/shared/HTTPError';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import { getHostName } from '../../utils/sisUtils';

class ErrorMessage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      location: { origin = '' }
    } = window;
    gtmEventPush({
      event: 'user_communication',
      event_category: 'user interactions',
      event_action: 'user_communication',
      event_label: this.props.message,
      store_type: getHostName(origin) || 'AJIO'
    });
    if (this.props.autoClose) {
      this.autoCloseTimeout = setTimeout(() => {
        this.props.onClose();
      }, 3000);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.autoCloseTimeout);
  }

  onActionClick = e => {
    if(this.props.onClose) {
      this.props.onClose();
    }
    this.props.selectSizeError('');
    this.props.selectSizeErrorQuickview('');
    this.props.setErrorObject();
    let { device = '' } = this.props;

    if (device == 'mobile') {
      this.props.closeAllMessage();
    }
  };

  render() {
    let { showCloseButton = true, showInfoIcon = true, autoClose = false } = this.props;
    return (
      <div>
        {showInfoIcon && (
          <span className="ic-info-error">
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </span>
        )}
        <span
          id="error-tooltip"
          className="msg-content"
          aria-live="assertive"
          role="alert"
        >
          {this.props.message}
        </span>
        {showCloseButton && <span className="ic-error-close" onClick={this.onActionClick} />}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    selectSizeErrorQuickview: message => dispatch(actions.selectSizeErrorQuickview(message)),
    selectSizeError: message => dispatch(actions.selectSizeError(message)),
    setErrorObject: () => dispatch(setErrorObject({})),
    closeAllMessage: () => dispatch(actions.closeAllMessage())
  };
};

export default ErrorMessage = connect(null, mapDispatchToProps)(ErrorMessage);
